import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";

const epochToYmdUTC = (ts, timestampInSeconds) => {
  if (ts === null || ts === undefined || ts === "") return "";

  const n = Number(ts);
  if (!Number.isFinite(n)) return "";

  const ms = timestampInSeconds ? n * 1000 : n;
  const d = new Date(ms);

  const yyyy = d.getUTCFullYear();
  const mm = String(d.getUTCMonth() + 1).padStart(2, "0");
  const dd = String(d.getUTCDate()).padStart(2, "0");
  return `${yyyy}-${mm}-${dd}`;
};

const isValidIsoYmd = (str, minYear) => {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(str)) return false;

  const [y, m, d] = str.split("-").map(Number);
  if (y < minYear) return false;

  const dt = new Date(Date.UTC(y, m - 1, d));
  return (
    dt.getUTCFullYear() === y &&
    dt.getUTCMonth() === m - 1 &&
    dt.getUTCDate() === d
  );
};

const isoYmdToEpochUtcMidnight = (str, timestampInSeconds) => {
  const [y, m, d] = str.split("-").map(Number);
  const utcMs = Date.UTC(y, m - 1, d, 0, 0, 0, 0);
  return timestampInSeconds ? Math.floor(utcMs / 1000) : utcMs;
};

const NewDynamicDate = ({
  value = null,
  valueKey = "",
  placeholder = "Select a date...",
  isUpdated = false,
  isRequired = false,
  onChange,
  timestampInSeconds = true,
  inputWidth = 85,
  minYear = 1900,
}) => {
  const requiredCheck = isRequired && !value;

  const [draft, setDraft] = useState(() =>
    epochToYmdUTC(value, timestampInSeconds),
  );

  useEffect(() => {
    setDraft(epochToYmdUTC(value, timestampInSeconds));
  }, [value, timestampInSeconds]);

  return (
    <Form.Control
      type="date"
      style={{ width: `${inputWidth}%` }}
      value={draft}
      placeholder={placeholder}
      min={`${minYear}-01-01`}
      className={`mt-1 text-input ${
        isUpdated ? "updated" : requiredCheck ? "required" : ""
      }`}
      onChange={(e) => {
        const next = e.target.value;
        setDraft(next);

        if (next === "") {
          onChange({ key: valueKey, value: null });
          return;
        }

        if (isValidIsoYmd(next, minYear)) {
          onChange({
            key: valueKey,
            value: isoYmdToEpochUtcMidnight(next, timestampInSeconds),
          });
        }
      }}
      onBlur={() => {
        if (draft && !isValidIsoYmd(draft, minYear)) {
          setDraft("");
          onChange({ key: valueKey, value: null });
        }
      }}
    />
  );
};

export default NewDynamicDate;
